<template>
  <v-container>
    <div>
      <v-layout>
        <v-flex xs12 sm6 offset-sm6>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
    </div>
    <br />
    <br />
    <v-data-table
      :headers="headers"
      :items="patientVaccines"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left"> {{ props.item.nombrePaciente }} </td>
        <td class="text-xs-left">{{ props.item.patientRouteSheet.patient.company.name }}</td>
        <td class="text-xs-left">{{ props.item.vaccine.name }}</td>
        <td class="text-xs-left">{{ props.item.dateVaccine }}</td>
        <td class="text-xs-left">{{ props.item.dateExpire }}</td>                
      </template>
      <v-alert
        slot="no-results"
        :value="true"
        color="error"
        icon="warning"
      >No se han encontrado resultados para "{{ search }}".</v-alert>
    </v-data-table>
  </v-container>
</template>
<script>
    export default {
        data() {
            return {               
                search: '',                
                headers: [
                    {text: 'Paciente', value: 'nombrePaciente'},
                    {text: 'Empresa', value: 'patientRouteSheet.patient.company.name'},
                    {text: 'Vacuna', value: 'vaccine.name'},
                    {text: 'Fecha vacuna', value: 'dateVaccine'},
                    {text: 'Vence', value: 'dateExpire'}                    
                ],
                patientVaccines: [],
                red: 'background-color: red;',
                yellow: 'background-color: yellow;'
            };
        },
        methods: {
            loadData() {                
                this.patientVaccines = [];                   
                this.$store.dispatch('getAlerts')
                .then(response => {
                    for (var i=0; i<response.data.length; i++) {
                      var alerta = response.data[i];
                      alerta.nombrePaciente = alerta.patientRouteSheet.patient.firstLastName 
                                              + " " + alerta.patientRouteSheet.patient.secondLastName 
                                              + " " + alerta.patientRouteSheet.patient.firstLastName 
                                              + " " + alerta.patientRouteSheet.patient.secondName;
                    }               
                    this.patientVaccines.push(...response.data);
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                });
            }
        },
        created() {
            this.loadData();
        }
    }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/reports/AlertsReport.vue